var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockOpenSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.86693 4.13281H8.30026H7.16693H2.06693C1.44359 4.13281 0.933594 4.64281 0.933594 5.26615V10.9328C0.933594 11.5561 1.44359 12.0661 2.06693 12.0661H8.86693C9.49026 12.0661 10.0003 11.5561 10.0003 10.9328V5.26615C10.0003 4.64281 9.49026 4.13281 8.86693 4.13281ZM8.86693 10.9328H2.06693V5.2661H8.86693V10.9328ZM6.60026 8.09935C6.60026 8.72268 6.09026 9.23268 5.46693 9.23268C4.84359 9.23268 4.33359 8.72268 4.33359 8.09935C4.33359 7.47602 4.84359 6.96602 5.46693 6.96602C6.09026 6.96602 6.60026 7.47602 6.60026 8.09935Z",
    fill: "#148235"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16732 4.70007V3.56673C7.16732 2.00273 8.43665 0.733398 10.0007 0.733398C11.5647 0.733398 12.834 2.00273 12.834 3.56673C12.834 3.56673 12.834 3.88877 12.834 4.1334C12.3664 4.1334 11.8764 4.1334 11.7007 4.1334V3.56673C11.7007 2.62607 10.9413 1.86673 10.0007 1.86673C9.05998 1.86673 8.30065 2.62607 8.30065 3.56673V4.70007H7.16732Z",
    fill: "#148235"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockOpenSmall);
export default __webpack_public_path__ + "static/media/lock-open-small.b1e6c9d84d1b0ddb2db147864b78971b.svg";
export { ForwardRef as ReactComponent };